export default function(
    breakpoints = {
        breakpoint0: 0,
        breakpoint600: 600,
        breakpoint768: 768,
        breakpoint1000: 1000,
        breakpoint1200: 1200
    },
    defaultBreakpoint = "breakpoint0"
) {
    return {
        name: "responsive-media-query",
        computed: {
            $mq() {
                return this.currentBreakpoint;
            }
        },
        data() {
            return {
                currentBreakpoint: defaultBreakpoint
            };
        },
        mounted() {
            this.subscribers = {};
            const mediaQueries = this.convertBreakpointsToMediaQueries(breakpoints);
            const enter = key => () => {
                this.currentBreakpoint = key;
            };
            for (const key in mediaQueries) {
                const mediaQuery = mediaQueries[key];
                this.subscribers[key] = this.subscribeToMediaQuery(mediaQuery, enter(key));
            }
        },
        methods: {
            convertBreakpointsToMediaQueries(breakpoints) {
                const keys = Object.keys(breakpoints);
                const values = keys.map(key => breakpoints[key]);
                const breakpointValues = values.map((i, index, arr) => {
                    if (index !== arr.length - 1) {
                        return [i, arr[index + 1] - 1];
                    }
                    return [i];
                });

                return breakpointValues.reduce((prev, value, index) => {
                    const minWidth = value[0];
                    const maxWidth = value[1];
                    return {
                        ...prev,
                        [`${keys[index]}`]: maxWidth ? `(min-width: ${minWidth}px) and (max-width: ${maxWidth}px)` : `(min-width: ${minWidth}px)`
                    };
                }, {});
            },
            subscribeToMediaQuery(mediaQuery, enter) {
                const mediaQueryList = window.matchMedia(mediaQuery);
                const cb = ({ matches }) => {
                    if (matches) {
                        enter();
                    }
                };
                cb(mediaQueryList);
                mediaQueryList.addListener(cb);
                return {
                    unSubscribeToMediaQuery: () => {
                        mediaQueryList.removeListener(cb);
                    }
                };
            }
        },
        destroyed() {
            if (this.subscribers) {
                for (const key in this.subscribers) {
                    const subscriber = this.subscribers[key];
                    subscriber.unSubscribeToMediaQuery();
                }
            }
            this.subscribers = null;
        }
    };
}
